import React from 'react';
import { FederationMembersPage } from '../../components/FederationMembersPage';
const members = [{
  name: 'Тимко Євген',
  role: 'Старший тренер',
  email: 'evgenitimko@gmail.com'
}, {
  name: 'Горбенко Мстислав',
  role: 'МСМК, інструктор з альпінізму',
  email: 'm.gorbenko@umcf.org.ua'
}, {
  name: 'Олівсон Олександр',
  role: 'КМСУ, інструктор з альпінізму',
  email: 'olivson63@gmail.com'
}];
export function AlpinismCoachCouncil() {
  return <FederationMembersPage title="Тренерська рада" subtitle="Тренерська рада комітету альпінізму ФАіСУ" members={members} data-id="element-385" />;
}